
import Hero from './components/Hero';
import IndustryOverview from './components/IndustryOverview';
import ChromeMarket from './components/ChromeMarket';
import ClientPortfolio from './components/ClientPortfolio';
import MarketCTA from './components/MarketCTA';

export default function ProductMarket() {
  return (
    <div className="min-h-screen">
      <Hero />
      <IndustryOverview />
      <ChromeMarket />
      <ClientPortfolio />
      <MarketCTA />
    </div>
  );
}
